import { ART_WORK_URL, BASE_URL } from "../../domain/model/API";
import { IArtworkAPIRequest } from "../../domain/model/IArtworkAPIRequest";
import { IArtworkAPIResponse } from "../../domain/model/IArtworkAPIResponse";
import { sleep } from "./sleep";

const textarea = document.createElement("textarea");

function decodeHtmlEntities(str: string) {
  textarea.innerHTML = str;
  return textarea.value;
}

const artworkAPIRequest = async ({
  delay = 0,
  attempt = 0,
}: IArtworkAPIRequest): Promise<IArtworkAPIResponse> => {
  const maxDelay = 1000 * 60 * 2;
  const maxAttempt = 10;

  if (attempt === maxAttempt) return null;

  await sleep(Math.min(maxDelay, delay));

  try {
    let response = await fetch(`${BASE_URL}${ART_WORK_URL}`, { method: "GET" });

    if (response.status > 299 || response.status < 200 || !response.ok) {
      throw Error("not ok");
    }

    const buffer = await response.arrayBuffer();

    const decoder = new TextDecoder("iso-8859-2"); // vagy "iso-8859-2" windows-1250
    const text = decoder.decode(buffer);

    return decodeHtmlEntities(text);
  } catch (e) {
    console.warn(`artworkAPIRequest failed on attempt ${attempt}`, e);
    console.log(e);
    return await artworkAPIRequest({
      delay: delay + 2500,
      attempt: attempt + 1,
    });
  }
};

export default artworkAPIRequest;
